import React from 'react';
import Terms from '../views/App/terms/Terms';

const termsRoutes = () => [
  {
    id: 'terms',
    label: 'Terms',
    path: '/app/terms',
    component: <Terms />,
    disabled: false,
    show: true,
    showInNavbar: false,
    subRoutes: [],
  },
];

export default termsRoutes;
